module.exports = __webpack_public_path__ + "static/img/123.80e3af2.png";